  <div id="mainContent" class="container">
<button mat-raised-button class="btn-theme" style="float:right" matTooltip="Click to add employee" matTooltipPosition="left"
(click)="openModal(modalContent,'add')">
    <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Employee
</button>
<br><br>

</div>


<ng-template #modalContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt">
      <h5 class="modal-title" id="modal-basic-title">Add Employee</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pt-0" style="">
        <div class="row " style="margin: 0% 0% 1% 0%;">
            <div class="col-md-12" style="padding: 0%;">
                <div class="col-sm-2" style="padding: 0px;">
                    <div class="form-group mb-0">
                        <label for="firstName" class="mb-0">Type :</label>
                        <select class="form-control form-control-xs" id="empType" name="empType" [(ngModel)]="empType">
                          <option value="">Select Type</option>
                          <option *ngFor="let empType of employeeTypeList" [value]="empType.name">{{empType.name}}</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-3"></div>
                  <div class="col-sm-3"></div>
                  <div class="col-sm-3"></div>
            </div>
        </div>
        <!-- Employee Form Starts -->
        <form [formGroup]="employeeForm">
            {{employeeForm.invalid}}
            <!-- Employee Personal Details Starts -->
            <div class="row">
                <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
                <h6 class="card-subtitle text-muted">Employee Personal Details</h6>
                </div>
                <div class="col-md-12">
                    <div class="row mb-1">
                        <div class="col-sm-3">
                            <div class="form-group mb-0">
                            <label for="firstName" class="mb-0">First name :</label>
                            <input id="firstName" name="firstName" type="text" class="form-control form-control-xs"
                            formControlName="firstName" [class.is-invalid]="employeeFormErrors.firstName && employeeFormSubmitted">
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group mb-0">
                            <label for="middleName" class="mb-0">Middle name :</label>
                            <input id="middleName" name="middleName"  type="text" class="form-control form-control-xs"
                            formControlName="middleName" [class.is-invalid]="employeeFormErrors.middleName && employeeFormSubmitted">
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group mb-0">
                                <label for="lastName" class="mb-0">Last name :</label>
                                <input id="lastName" name="lastName" type="text" class="form-control form-control-xs"
                                formControlName="lastName" [class.is-invalid]="employeeFormErrors.lastName && employeeFormSubmitted">
                                </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group mb-0">
                            <label for="dateOfBirth" class="mb-0">Date Of Birth :</label>
                            <div class="input-group">
                            <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="dateOfBirth"
                            formControlName="dateOfBirth" ngbDatepicker #dateOfBirth="ngbDatepicker" [class.is-invalid]="employeeFormErrors.dateOfBirth && employeeFormSubmitted">
                            <div class="input-group-append">
                            <button class="btn btn-outline-theme calendar" (click)="dateOfBirth.toggle()" type="button"></button>
                            </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-sm-3">
                                <div class="form-group mb-0">
                                <label for="bloodGroup" class="mb-0">Blood Group :</label>
                                <input id="bloodGroup" name="bloodGroup" type="text" class="form-control form-control-xs"
                                formControlName="bloodGroup" [class.is-invalid]="employeeFormErrors.bloodGroup && employeeFormSubmitted">
                                </div>
                        </div>
                        <div class="col-sm-3">
                                <div class="form-group mb-0">
                                <label for="panNumber" class="mb-0">PAN Number :</label>
                                <input id="panNumber" name="panNumber" type="text" class="form-control form-control-xs"
                                formControlName="panNumber" [class.is-invalid]="employeeFormErrors.panNumber && employeeFormSubmitted">
                                </div>
                        </div>
                        <div class="col-sm-3">
                                <div class="form-group mb-0">
                                <label for="aadharNumber" class="mb-0">Aadhar Number :</label>
                                <input id="aadharNumber" name="aadharNumber" type="text" class="form-control form-control-xs"
                                formControlName="aadharNumber" [class.is-invalid]="employeeFormErrors.aadharNumber && employeeFormSubmitted">
                                </div>
                        </div>
                        <div class="col-sm-3">
                                <div class="form-group mb-0">
                                <label for="qualification" class="mb-0">Qualification :</label>
                                <input id="qualification" name="qualification" type="text" class="form-control form-control-xs"
                                formControlName="qualification" [class.is-invalid]="employeeFormErrors.qualification && employeeFormSubmitted">
                                </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-sm-3">
                                <div class="form-group mb-0">
                                <label for="certification" class="mb-0">Certification :</label>
                                <input id="certification" name="certification" type="text" class="form-control form-control-xs"
                                formControlName="certification" [class.is-invalid]="employeeFormErrors.certification && employeeFormSubmitted">
                                </div>
                        </div>
                        <div class="col-sm-3">
                            <label for="firstName" class="mb-0">Gender :</label>
                            <div class="form-group mb-0" style="margin-top: -2%;">
                            <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="gender" id="gender1" [value]="'Male'"
                            formControlName="gender">
                            <label class="col-form-label" style="font-weight: 400;">Male</label>
                            </div>
                            <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="gender" id="gender2" [value]="'Female'"
                            formControlName="gender">
                            <label class="col-form-label" style="font-weight: 400;">Female</label>
                            </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <label for="firstName" class="mb-0">Profile Status :</label>
                            <div class="form-group mb-0" style="margin-top: -2%;">
                            <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="profileStatus" id="profileStatus1" [value]="'active'"
                            formControlName="profileStatus">
                            <label class="col-form-label" style="font-weight: 400;">Active</label>
                            </div>
                            <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="profileStatus" id="profileStatus2" [value]="'closed'"
                            formControlName="profileStatus">
                            <label class="col-form-label" style="font-weight: 400;">Closed</label>
                            </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <label for="firstName" class="mb-0">Login Access :</label>
                            <div class="form-group mb-0" style="margin-top: 0%;">
                            <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" name="loginAccess" id="loginAccess" formControlName="loginAccess">
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        <!-- Employee Personal Details Ends -->
        <!-- Employee Contact Details Starts -->
    <div class="row">
    <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
    <h6 class="card-subtitle text-muted">Employee Contact Details</h6>
    </div>
    <div class="col-md-12">
        <div class="row mb-1">
            <div class="col-sm-3">
                <div class="form-group mb-0">
                <label for="email" class="mb-0">Official Email ID :</label>
                <input id="email" name="email" type="email" class="form-control form-control-xs"
                formControlName="email" [class.is-invalid]="employeeFormErrors.email && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="personalEmail" class="mb-0">Personal Email ID :</label>
                <input id="personalEmail" name="personalEmail" type="email" class="form-control form-control-xs"
                formControlName="personalEmail" [class.is-invalid]="employeeFormErrors.personalEmail && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="officalMobileNumber" class="mb-0">Official Mobile Number :</label>
                <input id="officalMobileNumber" name="officalMobileNumber" type="text" class="form-control form-control-xs"
                formControlName="officalMobileNumber" [class.is-invalid]="employeeFormErrors.officalMobileNumber && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="contactMobileNumber" class="mb-0">Contact Number Mobile :</label>
                <input id="contactMobileNumber" name="contactMobileNumber" type="text" class="form-control form-control-xs"
                formControlName="contactMobileNumber" [class.is-invalid]="employeeFormErrors.contactMobileNumber && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="landlineStdCode" class="mb-0">LandLine STD Code :</label>
                <input id="landlineStdCode" name="landlineStdCode" type="text" class="form-control form-control-xs"
                formControlName="landlineStdCode" [class.is-invalid]="employeeFormErrors.landlineStdCode && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="landlineNumber" class="mb-0">LandLine STD Number :</label>
                <input id="landlineNumber" name="landlineNumber" type="text" class="form-control form-control-xs"
                formControlName="landlineNumber" [class.is-invalid]="employeeFormErrors.landlineNumber && employeeFormSubmitted">
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact Number1 :</label>
                <input id="emergencyContactNumber1" name="emergencyContactNumber1" type="text" class="form-control form-control-xs"
                formControlName="emergencyContactNumber1" [class.is-invalid]="employeeFormErrors.emergencyContactNumber1 && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact1 Name :</label>
                <input id="emergencyContactName1" name="emergencyContactName1" type="text" class="form-control form-control-xs"
                formControlName="emergencyContactNumber1" [class.is-invalid]="employeeFormErrors.emergencyContactNumber1 && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact1 Relation :</label>
                <input id="emergencyContactRelation1" name="emergencyContactRelation1" type="text" class="form-control form-control-xs"
                formControlName="emergencyContactRelation1" [class.is-invalid]="employeeFormErrors.emergencyContactRelation1 && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact Number2 :</label>
                <input id="emergencyContactNumber2" name="emergencyContactNumber2" type="text" class="form-control form-control-xs"
                formControlName="emergencyContactNumber2" [class.is-invalid]="employeeFormErrors.emergencyContactNumber2 && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact2 Name :</label>
                <input id="emergencyContact2Name" name="emergencyContact2Name" type="text" class="form-control form-control-xs"
                formControlName="emergencyContactNumber2" [class.is-invalid]="employeeFormErrors.emergencyContactName2 && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact2 Relation :</label>
                <input id="emergencyContactRelation2" name="emergencyContactRelation2" type="text" class="form-control form-control-xs"
                formControlName="emergencyContactRelation2" [class.is-invalid]="employeeFormErrors.emergencyContactRelation2 && employeeFormSubmitted">
                </div>


            </div>
            <div class="col-sm-3" formGroupName="permanentAddress">
                    <div class="form-group mb-0">
                    <label for="" class="mb-0">Permanent Address :</label>
                    <input id="address1" name="address" type="text" class="form-control form-control-xs"
                    formControlName="address" [class.is-invalid]="employeeFormErrors.address && employeeForm.controls.permanentAddress.controls.address.invalid && employeeFormSubmitted">
                    </div>
                    <div class="form-group mb-0">
                    <label for="" class="mb-0">Permanent Address City :</label>
                    <input id="city1" name="city" type="text" class="form-control form-control-xs"
                    formControlName="city" [class.is-invalid]="employeeFormErrors.city && employeeForm.controls.permanentAddress.controls.city.invalid && employeeFormSubmitted">
                    </div>
                    <div class="form-group mb-0">
                    <label for="" class="mb-0">Permanent Address SateCode :</label>
                    <input id="state1" name="state" type="text" class="form-control form-control-xs"
                    formControlName="state" [class.is-invalid]="employeeFormErrors.state && employeeForm.controls.permanentAddress.controls.state.invalid && employeeFormSubmitted">
                    </div>
                    <div class="form-group mb-0">
                    <label for="" class="mb-0">Permanent Address Pincode :</label>
                    <input id="postalCode1" name="postalCode" type="text" class="form-control form-control-xs"
                    formControlName="postalCode" [class.is-invalid]="employeeFormErrors.postalCode && employeeForm.controls.permanentAddress.controls.postalCode.invalid && employeeFormSubmitted">
                    </div>
                    <div class="form-group mb-0">
                    <label for="" class="mb-0">Country :</label>
                    <input id="country1" name="country" type="text" class="form-control form-control-xs"
                    formControlName="country" [class.is-invalid]="employeeFormErrors.country && employeeForm.controls.permanentAddress.controls.country.invalid && employeeFormSubmitted">
                    </div>
            </div>
            <div class="col-sm-3" formGroupName="localAddress">
                <div class="form-group mb-0">
                <label for="" class="mb-0">Local Address :</label>
                <input id="address2" name="address" type="text" class="form-control form-control-xs"
                formControlName="address" [class.is-invalid]="employeeFormErrors.address && employeeForm.controls.localAddress.controls.address.invalid && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="" class="mb-0">Local Address City :</label>
                <input id="city2" name="city" type="text" class="form-control form-control-xs"
                formControlName="city" [class.is-invalid]="employeeFormErrors.city && employeeForm.controls.localAddress.controls.city.invalid && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="" class="mb-0">Local Address SateCode :</label>
                <input id="state2" name="state" type="text" class="form-control form-control-xs"
                formControlName="state" [class.is-invalid]="employeeFormErrors.state && employeeForm.controls.localAddress.controls.state.invalid && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="" class="mb-0">Local Address Pincode :</label>
                <input id="postalCode2" name="postalCode" type="text" class="form-control form-control-xs"
                formControlName="postalCode" [class.is-invalid]="employeeFormErrors.postalCode && employeeForm.controls.localAddress.controls.postalCode.invalid && employeeFormSubmitted">
                </div>
                <div class="form-group mb-0">
                <label for="" class="mb-0">Country :</label>
                <input id="country2" name="country" type="text" class="form-control form-control-xs"
                formControlName="country" [class.is-invalid]="employeeFormErrors.country && employeeForm.controls.localAddress.controls.country.invalid && employeeFormSubmitted">
                </div>
            </div>
        </div>
    </div>
    </div>
    <!-- Employee Contact Details Ends -->
    <!-- Employee Official Details Starts -->
    <div class="row">
        <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
        <h6 class="card-subtitle text-muted">Employee Official Details</h6>
        </div>
        <div class="col-md-12">
            <div class="row mb-1">
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label for="" class="mb-0">Branch :</label>
                        <select class="form-control form-control-xs" id="branch" name="branch"
                        formControlName="branch" [class.is-invalid]="employeeFormErrors.branch && employeeFormSubmitted">
                          <option value="">Select</option>
                          <!-- <option *ngFor="let task of taskList" [value]="task.id">{{ task.name }}</option> -->
                        </select>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label for="" class="mb-0">Reporting Manager :</label>
                        <select class="form-control form-control-xs" id="reportingManager" name="reportingManager"
                        formControlName="reportingManager" [class.is-invalid]="employeeFormErrors.reportingManager && employeeFormSubmitted">
                          <option value="">Select</option>
                          <!-- <option *ngFor="let task of taskList" [value]="task.id">{{ task.name }}</option> -->
                        </select>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label for="" class="mb-0">Reporting Partner :</label>
                        <select class="form-control form-control-xs" id="reportingPartner" name="reportingPartner"
                        formControlName="reportingPartner" [class.is-invalid]="employeeFormErrors.reportingPartner && employeeFormSubmitted">
                          <option value="">Select</option>
                          <!-- <option *ngFor="let task of taskList" [value]="task.id">{{ task.name }}</option> -->
                        </select>
                    </div>
                </div>
                <div class="col-sm-3">
                        <div class="form-group mb-0">
                        <label for="joiningDate" class="mb-0">Joining Date :</label>
                        <div class="input-group" >
                        <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="joiningDate"
                        ngbDatepicker #joiningDate="ngbDatepicker" formControlName="joiningDate" [class.is-invalid]="employeeFormErrors.joiningDate && employeeFormSubmitted">
                        <div class="input-group-append">
                        <button class="btn btn-outline-theme calendar" (click)="joiningDate.toggle()" type="button"></button>
                        </div>
                        </div>
                        </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label class="mb-0">Laptop Service Tag Number :</label>
                        <input id="laptopServiceTagNumber" name="laptopServiceTagNumber" type="text" class="form-control form-control-xs"
                        formControlName="laptopServiceTagNumber" [class.is-invalid]="employeeFormErrors.laptopServiceTagNumber && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label class="mb-0">DataCard Number :</label>
                        <input id="dataCardNumber" name="dataCardNumber" type="text" class="form-control form-control-xs"
                        formControlName="dataCardNumber" [class.is-invalid]="employeeFormErrors.dataCardNumber && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label class="mb-0">Bank Account Name And Branch : </label>
                        <input id="bankAcountName" name="bankAcountName" type="text" class="form-control form-control-xs"
                        formControlName="bankAcountName" [class.is-invalid]="employeeFormErrors.bankAcountName && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label class="mb-0">Bank Account Numberr :</label>
                        <input id="bankAccountNumber" name="bankAccountNumber" type="text" class="form-control form-control-xs"
                        formControlName="bankAccountNumber" [class.is-invalid]="employeeFormErrors.bankAccountNumber && employeeFormSubmitted">
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label for="" class="mb-0">Designation :</label>
                        <select class="form-control form-control-xs" id="designation" name="designation"
                        formControlName="designation" [class.is-invalid]="employeeFormErrors.designation && employeeFormSubmitted">
                          <option value="">Select</option>
                          <!-- <option *ngFor="let task of taskList" [value]="task.id">{{ task.name }}</option> -->
                        </select>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label for="" class="mb-0">Role :</label>
                        <select class="form-control form-control-xs" id="role" name="role"
                        formControlName="role" [class.is-invalid]="employeeFormErrors.role && employeeFormSubmitted">
                          <option value="">Select</option>
                          <!-- <option *ngFor="let task of taskList" [value]="task.id">{{ task.name }}</option> -->
                        </select>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                    <label class="mb-0">Membership Number :</label>
                    <input id="membershipNumber" name="membershipNumber" type="text" class="form-control form-control-xs"
                    formControlName="membershipNumber" [class.is-invalid]="employeeFormErrors.membershipNumber && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                    <label class="mb-0">Probation Period :</label>
                    <input id="probabtionPeriod" name="probabtionPeriod" type="text" class="form-control form-control-xs"
                    formControlName="probabtionPeriod" [class.is-invalid]="employeeFormErrors.probabtionPeriod && employeeFormSubmitted">
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                    <label class="mb-0">No.Of Articles Eligible to be trained: :</label>
                    <input id="articleTrainingLimit" name="articleTrainingLimit" type="text" class="form-control form-control-xs"
                    formControlName="articleTrainingLimit" [class.is-invalid]="employeeFormErrors.articleTrainingLimit && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label for="" class="mb-0">Background Verification Completed :</label>
                        <select class="form-control form-control-xs" id="isVerified" name="isVerified"
                        formControlName="isVerified" [class.is-invalid]="employeeFormErrors.isVerified && employeeFormSubmitted">
                          <option value="">Select</option>
                          <!-- <option *ngFor="let task of taskList" [value]="task.id">{{ task.name }}</option> -->
                        </select>
                    </div>
                </div>
                <div class="col-sm-3">
                        <div class="form-group mb-0">
                        <label for="" class="mb-0">Confirmation Date :</label>
                        <div class="input-group" >
                        <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="confirmationDate" ngbDatepicker
                        #confirmationDate="ngbDatepicker" formControlName="confirmationDate" [placement]="'top'" [class.is-invalid]="employeeFormErrors.confirmationDate && employeeFormSubmitted">
                        <div class="input-group-append">
                        <button class="btn btn-outline-theme calendar" (click)="confirmationDate.toggle()" type="button"></button>
                        </div>
                        </div>
                        </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label class="mb-0">Source Of Verification :</label>
                        <input id="verificationSource" name="verificationSource" type="text" class="form-control form-control-xs"
                        formControlName="verificationSource" [class.is-invalid]="employeeFormErrors.verificationSource && employeeFormSubmitted">
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-3">
                    <div class="form-group mb-0">
                        <label class="mb-0">Remark :</label>
                        <input id="remark" name="remark" type="text" class="form-control form-control-xs"
                        formControlName="remark" [class.is-invalid]="employeeFormErrors.remark && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-3">

                </div>
                <div class="col-sm-3">

                </div>
                <div class="col-sm-3">

                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-3"></div>
                <div class="col-sm-3"></div>
                <div class="col-sm-3"></div>
                <div class="col-sm-3"></div>
            </div>
        </div>
        </div>
    <!-- Employee Official Details Ends -->
    <!-- Employee CTC Details Starts -->
    <div class="row" *ngIf="empType!='Article'">
        <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
        <h6 class="card-subtitle text-muted">Employee CTC Details 123</h6>
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-2">
                    <div class="form-group mb-0">
                    <label class="mb-0">Basic :</label>
                    <input id="basic" name="basic" type="text" class="form-control form-control-xs"
                    formControlName="basic" [class.is-invalid]="employeeFormErrors.basic && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group mb-0">
                    <label class="mb-0">HRA :</label>
                    <input id="hra" name="hra" type="text" class="form-control form-control-xs"
                    formControlName="hra" [class.is-invalid]="employeeFormErrors.hra && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group mb-0">
                    <label class="mb-0">Other Allowances :</label>
                    <input id="otherAllowance" name="otherAllowance" type="text" class="form-control form-control-xs"
                    formControlName="otherAllowance" [class.is-invalid]="employeeFormErrors.otherAllowance && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group mb-0">
                    <label class="mb-0">Conveyance Allowance :</label>
                    <input id="conveyanceAllowance" name="conveyanceAllowance" type="text" class="form-control form-control-xs"
                    formControlName="conveyanceAllowance" [class.is-invalid]="employeeFormErrors.conveyanceAllowance && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group mb-0">
                    <label class="mb-0">Medical Allowance :</label>
                    <input id="medicalAllowance" name="medicalAllowance" type="text" class="form-control form-control-xs"
                    formControlName="medicalAllowance" [class.is-invalid]="employeeFormErrors.medicalAllowance && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group mb-0">
                    <label class="mb-0">Education Allowance :</label>
                    <input id="educationAllowance" name="educationAllowance" type="text" class="form-control form-control-xs"
                    formControlName="educationAllowance" [class.is-invalid]="employeeFormErrors.educationAllowance && employeeFormSubmitted">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2">
                    <div class="form-group mb-0">
                    <label class="mb-0">Child Allowance :</label>
                    <input id="childAllowance" name="childAllowance" type="text" class="form-control form-control-xs"
                    formControlName="childHostelAllowance" [class.is-invalid]="employeeFormErrors.childHostelAllowance && employeeFormSubmitted">
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group mb-0">
                    <label class="mb-0">From Date :</label>
                        <div class="input-group">
                        <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="fromDate" ngbDatepicker
                        #fromDate="ngbDatepicker" formControlName="fromDate" [class.is-invalid]="employeeFormErrors.fromDate && employeeFormSubmitted" [placement]="'top'">
                        <div class="input-group-append">
                          <button class="btn btn-outline-theme calendar" (click)="fromDate.toggle()" type="button"></button>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group mb-0">
                    <label class="mb-0">To Date :</label>
                        <div class="input-group">
                        <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="toDate" ngbDatepicker #toDate="ngbDatepicker"
                        formControlName="toDate" [class.is-invalid]="employeeFormErrors.toDate && employeeFormSubmitted" [placement]="'top'">
                        <div class="input-group-append">
                        <button class="btn btn-outline-theme calendar" (click)="toDate.toggle()" type="button"></button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        </div>
    <!-- Employee CTC Details Ends -->
    </form>
    <!-- Employee Form Ends -->
    </div>
    <div class="modal-footer" style="">
        <div class="row col-md-12">
            <div class="col-sm-8"></div>
            <div class="col-sm-2">
                <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
            </div>
            <div class="col-sm-2">
                <button  type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveBtnClick()">Save</button>
            </div>
        </div>
    </div>
</ng-template>
